<style lang="less" scoped>
  @import "../vars.less";

  .guide-page {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 98;
    height: 100%;
    width: 100%;
    flex-direction: column;
    justify-content: space-between;
    background-color: @dark-color;
    // background-color: #000028;
    padding: @space-large;
    color: #fff;
    font-size: 14px;
    .logo {
      width: 40%;
    }
    .guide-page-content {
      width: 80%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .fluid {
      width: 100%;
    }
    .title {
      font-size: 32px;
      padding-left: @space-normal;
      position: relative;
      bottom: -64px;
      &:before {
        position: absolute;
        content: "";
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 88%;
        width: 3px;
        border-radius: 3px;
        background-image: linear-gradient(to bottom, #00f2b4, #00ddd2);
      }
      p {
        line-height: 32px;
        margin: 0;
        padding: 0;
      }
      p:first-child {
        margin-bottom: @space-small;
      }
    }
  }
</style>

<template>
  <div class="guide-page" v-if="visible">
    <img alt="siemens logo" src="/images/logo-w.svg" class="logo" />
    <div class="guide-page-content">
      <img alt="siemens cognisphere fluid" src="/images/siemens-cognisphere-fluid.png"  class="fluid"/>
      <div class="title">
        <p>Siemens</p>
        <p>SI E2E Mobile</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'guide-page',
  data () {
    return {
      visible: !window.sessionStorage.getItem('loaded')
    }
  },
  mounted () {
    if (!window.sessionStorage.getItem('loaded')) {
      const timer = window.setTimeout(() => {
        this.visible = false
        window.sessionStorage.setItem('loaded', 'true')
        window.clearTimeout(timer)
      }, 3000)
    }
  }
}
</script>
